const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "elm_stage_funnel_session";
const EVENTS = new Set(["view_drum_stage_page", "start_drum_booking", "click_group_dates", "click_individual_booking", "choose_stage_mode", "select_stage_date", "configure_stage_started", "reach_stage_contact", "reach_stage_payment", "submit_stage_booking", "checkout_created", "complete_drum_booking", "stage_booking_error"]);
const FIELDS = ["source", "mode", "event_id", "participants", "payment"];

export const funnelSessionId = () => {
  if (typeof window === "undefined") return null;
  let session = window.sessionStorage.getItem(SESSION_KEY);
  if (!session) {
    session = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
    window.sessionStorage.setItem(SESSION_KEY, session);
  }
  return session.replace(/[^A-Za-z0-9_-]/g, "_").slice(0, 64);
};

const sendInternal = (name, params) => {
  if (!EVENTS.has(name)) return;
  const body = { session_id: funnelSessionId(), event: name, page: window.location.pathname };
  FIELDS.forEach((field) => { if (params[field] != null) body[field] = params[field]; });
  const payload = JSON.stringify(body);
  if (navigator.sendBeacon) {
    const accepted = navigator.sendBeacon(`${API}/analytics/funnel`, new Blob([payload], { type: "application/json" }));
    if (accepted) return;
  }
  fetch(`${API}/analytics/funnel`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
};

export const track = (name, params = {}) => {
  try {
    if (typeof window === "undefined") return;
    sendInternal(name, params);
    if (typeof window.gtag === "function") window.gtag("event", name, params);
    else if (typeof window.plausible === "function") window.plausible(name, { props: params });
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...params });
    window.dispatchEvent(new CustomEvent("elm:track", { detail: { name, params } }));
  } catch {
    /* jamais bloquant */
  }
};